import * as React from 'react';
import { IconButton, TooltipHost } from '@fluentui/react';
import { getAadTenant, getOdspFileLocation, isOdspResolvedUrl } from '@fluidx/utilities';
import { getFFXHostUxIcon } from '@fluidx/icons/lib/useIconNames/ffxHostUx';
import { useCancellableEffect } from '../../hooks/useCancellableEffect';
import { generateTooltipId } from '../../utilities/generateTooltipId';
import { containerToolbarButtonStyles } from './ContainerToolbarStyles';
/**
 * Button that takes the users to the location of their file
 */ export const FileLocationButton = /*#__PURE__*/ React.memo(function FileLocationButton(props) {
    const { title , logger , tokenProvider , container  } = props;
    const [fileUrl, setFileUrl] = React.useState(undefined);
    const containerResolvedUrl = container.resolvedUrl;
    if (containerResolvedUrl && isOdspResolvedUrl(containerResolvedUrl)) {
        // TODO: review for violation of rules of hooks (hooks must be called in React function component or custom hook)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useCancellableEffect((cancel)=>{
            Promise.race([
                cancel,
                getOdspFileLocation(containerResolvedUrl, tokenProvider, logger, getAadTenant(containerResolvedUrl.siteUrl, logger))
            ]).then((fileLocation)=>{
                if (fileLocation && fileLocation !== 'CANCELLED') {
                    setFileUrl(fileLocation);
                }
            }).catch(()=>{});
        }, []);
    }
    const tooltipId = generateTooltipId();
    return /*#__PURE__*/ React.createElement(TooltipHost, {
        content: title,
        id: tooltipId
    }, /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": title,
        "aria-describedby": tooltipId,
        styles: containerToolbarButtonStyles,
        iconProps: {
            iconName: getFFXHostUxIcon('FFXFabricFolder')
        },
        disabled: fileUrl === undefined,
        href: fileUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }));
});
